/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  GuildStakingAdapterMock,
  GuildStakingAdapterMockInterface,
} from "../GuildStakingAdapterMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
    ],
    name: "getExtraFeeRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ratio",
        type: "uint256",
      },
    ],
    name: "setExtraFeeRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class GuildStakingAdapterMock__factory {
  static readonly abi = _abi;
  static createInterface(): GuildStakingAdapterMockInterface {
    return new Interface(_abi) as GuildStakingAdapterMockInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): GuildStakingAdapterMock {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as GuildStakingAdapterMock;
  }
}
